export enum IntraVatManagement {
  AUTO = 'AUTO',
  INTRA_VAT = 'INTRA_VAT',
  NATIONAL_VAT = 'NATIONAL_VAT',
}
